export enum AddEditJobItemSteps {
  CUSTOMIZE = "customize",
}
